import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getSchoolById = createAsyncThunk<any, any>(
  types.GET_SCHOOL_BY_ID,
  async (schoolId: string) => {
    const school = await api.getSchoolById(schoolId);

    return school;
  },
);

export const updateSchoolById = createAsyncThunk<any, any>(
  types.UPDATE_SCHOOL_BY_ID,
  async ({ schoolId, data }: { schoolId: string; data: any }) => {
    const school = await api.updateSchoolById({ schoolId, data });

    return school;
  },
);
